import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { my_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

type PasswordField = "oldPassword" | "newPassword" | "confirmPassword";

// 1. définition du shéma Zod
const changeShema = z
  .object({
    oldPassword: z.string().min(8, {
      message: "Le mot de passe doit comporter au moins 8 caractères",
    }),
    newPassword: z.string().min(8, {
      message: "Le mot de passe doit comporter au moins 8 caractères",
    }),
    confirmPassword: z.string().min(8, {
      message: "Le mot de passe doit comporter au moins 8 caractères",
    }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: " Les mots de passe ne correspondent pas",
    path: ["confirmPassword"],
  })
  .refine((data) => data.oldPassword !== data.newPassword, {
    message: "Le nouveau mot de passe doit être différent de l'ancien",
    path: ["newPassword"],
  });

//2.Inference de type des données du formulaire
type ChangeFormData = z.infer<typeof changeShema>;

const ChangePassword = () => {
  const routes = my_routes;
  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  // Destructuration du shema pour la gestion du formulaire avec useForm
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<ChangeFormData>({
    resolver: zodResolver(changeShema),
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });

  // fonction de soumission du formulaire
  const onSubmit = async (data: ChangeFormData) => {
    try {
      // console.log("Données envoyées avec succes !:", data);
      throw new Error(
        "Une erreur s'est produite lors de la modification du mot de passe.",
      ); // Simulating an error for demonstration
    } catch (error) {
      // console.log("Erreur: ", error);
      setError("root", {
        message:
          error instanceof Error ? error.message : "Une erreur s'est produite",
      });
    }
  };

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  return (
    <div className="container-fuild">
      <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-4 col-sm-8 mx-auto p-4">
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                  <div>
                    <div className=" mx-auto mb-5 text-center">
                      <ImageWithBasePath
                        src="assets/img/authentication/Logo-campus.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </div>
                    <div className="card">
                      <div className="card-body p-4">
                        <div className=" mb-4">
                          <h2 className="mb-2">Changer Mot de passe ?</h2>
                          <p className="mb-0">
                            Entrez Nouveau mot de passe &amp; Confirmer le mot
                            de passe pour entrer à l'intérieur
                          </p>
                        </div>
                        {errors.root && (
                          <div className="alert alert-danger">
                            {errors.root.message}
                          </div>
                        )}
                        <div className="mb-3">
                          <label className="form-label" htmlFor="oldPassword">
                            Ancien mot de passe
                          </label>
                          <div className="pass-group">
                            <input
                              id="oldPassword"
                              {...register("oldPassword")}
                              type={
                                passwordVisibility.oldPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.oldPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("oldPassword")
                              }
                            ></span>
                          </div>
                          {errors.oldPassword && (
                            <span className="text-danger">
                              {errors.oldPassword.message}
                            </span>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Nouveau mot de passe
                          </label>
                          <div className="pass-group">
                            <input
                              id="newPassword"
                              {...register("newPassword")}
                              type={
                                passwordVisibility.newPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.newPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("newPassword")
                              }
                            ></span>
                          </div>
                          {errors.newPassword && (
                            <span className="text-danger">
                              {errors.newPassword.message}
                            </span>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label ">
                            Confirmer nouveau mot de passe
                          </label>
                          <div className="pass-group">
                            <input
                              id="confirmPassword"
                              {...register("confirmPassword")}
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.confirmPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                          {errors.confirmPassword && (
                            <span className="text-danger">
                              {errors.confirmPassword.message}
                            </span>
                          )}
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-primary w-100"
                          >
                            {isSubmitting
                              ? "En cours..."
                              : "Changer Mot de passe"}
                          </button>
                        </div>
                        <div className="text-center">
                          <h6 className="fw-normal text-dark mb-0">
                            Retour à l'{" "}
                            <Link to={routes.login} className="hover-a ">
                              {" "}
                              Authentification
                            </Link>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
